import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/Typography';
import { useThemes } from '@hooks/useThemes';
import { ResultsType } from '@types';
import styles from './Pagination.module.css';

export interface PaginationProps {
    loading: boolean;
    type: ResultsType;
}

export const Pagination: FC<PaginationProps> = ({ loading, type }) => {
    const { t } = useTranslation();

    const translations = {
        endOfProducts: t('pagination-component.end-of-products'),
        endOfWorkers: t('pagination-component.end-of-workers'),
        endOfMerchants: t('pagination-component.end-of-merchants'),
        endOfServices: t('pagination-component.end-of-services'),
        endOfPointsServices: t('pagination-component.end-of-points-services'),
        endOfOrders: t('pagination-component.end-of-orders'),
        endOfPromotions: t('pagination-component.end-of-promotions'),
    };

    const getEndOfText: () => string = useCallback(() => {
        switch (type) {
            case ResultsType.products:
                return translations.endOfProducts;
            case ResultsType.workers:
                return translations.endOfWorkers;
            case ResultsType.merchants:
                return translations.endOfMerchants;
            case ResultsType.services:
                return translations.endOfServices;
            case ResultsType.pointsServices:
                return translations.endOfPointsServices;
            case ResultsType.orders:
                return translations.endOfOrders;
            case ResultsType.promotions:
                return translations.endOfPromotions;
            default:
                return '';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type, t]);

    return (
        <div className="d-flex flex-column align-items-center pt-4 gap-5" data-testid="pagination">
            {loading ? (
                <Loader />
            ) : (
                <Typography classes="mb-0" color="muted">
                    <>
                        {getEndOfText()} <i className="fa-light fa-face-frown-slight" />
                    </>
                </Typography>
            )}
        </div>
    );
};

export const Loader: FC = () => {
    const { useGrayscaleTheme } = useThemes();

    return (
        <div
            className={
                // theme
                `${useGrayscaleTheme ? styles['theme-grayscale'] : ''}` +
                // other classes
                ` ${styles.loader}`
            }></div>
    );
};
